module.exports = __webpack_public_path__ + "static/listing-frontend-770ff237572e9b1f602e588db98ac497.png";